import { Alert, AlertKind } from './Alert'
import styles from './Alert.module.scss'

export function ErrorList({
  messages,
  kind = 'danger',
  onDismiss,
}: {
  messages: readonly string[]
  kind?: AlertKind
  onDismiss?: (message: string) => void
}) {
  if (messages.length === 0) {
    return null
  }

  return (
    <ul className={styles.list} id="error_explanation">
      {messages.map((message) => (
        <li key={message}>
          <Alert kind={kind} onDismiss={onDismiss ? () => onDismiss(message) : undefined}>
            {message}
          </Alert>
        </li>
      ))}
    </ul>
  )
}
